var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogsHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.46201558,1.76525607 C13.0070156,-0.438743926 19.3150156,2.28125607 21.5190156,7.82825607 C23.7230156,13.3752561 21.0030156,19.6812561 15.4560156,21.8852561 C14.1620156,22.3992561 12.8080156,22.6562561 11.4560156,22.6562561 C10.0010156,22.6562561 8.54801558,22.3582561 7.17201558,21.7652561 C4.51701558,20.6202561 2.46701558,18.5092561 1.39901558,15.8222561 C1.23601558,15.4112561 1.43601558,14.9462561 1.84701558,14.7832561 C2.25601558,14.6222561 2.72301558,14.8212561 2.88601558,15.2312561 C3.79601558,17.5212561 5.54301558,19.3202561 7.80601558,20.2962561 C10.0670156,21.2712561 12.5750156,21.3082561 14.8650156,20.3982561 C19.5920156,18.5202561 21.9100156,13.1462561 20.0320156,8.41925607 C18.1530156,3.69125607 12.7800156,1.37425607 8.05301558,3.25225607 C6.49201558,3.87225607 5.16801558,4.88825607 4.16901558,6.18425607 L4.16901558,6.18425607 L5.27401558,5.72425607 C5.68301558,5.55325607 6.15001558,5.74525607 6.32001558,6.15425607 C6.49001558,6.56225607 6.29801558,7.03025607 5.89001558,7.20025607 L5.89001558,7.20025607 L2.58301558,8.57825607 L2.58301558,8.57825607 C2.38401558,8.66825607 2.15301558,8.68325607 1.93701558,8.58925607 C1.61701558,8.45125607 1.44101558,8.13025607 1.46401558,7.80025607 L1.46401558,7.80025607 L1.00701558,4.33125607 C0.949015584,3.89325607 1.25701558,3.49125607 1.69501558,3.43325607 C2.13801558,3.37525607 2.53601558,3.68425607 2.59301558,4.12225607 L2.59301558,4.12225607 L2.76101558,5.39425607 C3.94801558,3.78225607 5.55501558,2.52225607 7.46201558,1.76525607 Z M11.4590156,4.85845607 C11.9010156,4.85845607 12.2590156,5.21645607 12.2590156,5.65845607 L12.2590156,5.65845607 L12.2590156,11.0254561 L15.1950156,11.0254561 C15.6370156,11.0254561 15.9950156,11.3834561 15.9950156,11.8254561 C15.9950156,12.2674561 15.6370156,12.6254561 15.1950156,12.6254561 L15.1950156,12.6254561 L11.4590156,12.6254561 C11.0170156,12.6254561 10.6590156,12.2674561 10.6590156,11.8254561 L10.6590156,11.8254561 L10.6590156,5.65845607 C10.6590156,5.21645607 11.0170156,4.85845607 11.4590156,4.85845607 Z",
    id: "path-f75b960b-4b66-498f-845f-5a9317ca3390"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.74170517%",
    y1: "10.6866036%",
    x2: "96.518208%",
    y2: "100.071406%",
    id: "linearGradient-f75b960b-4b66-498f-845f-5a9317ca3390"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA05D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-logsHistory"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-f75b960b-4b66-498f-845f-5a9317ca3390",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-f75b960b-4b66-498f-845f-5a9317ca3390"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#868B92",
    xlinkHref: "#path-f75b960b-4b66-498f-845f-5a9317ca3390"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "url(#linearGradient-f75b960b-4b66-498f-845f-5a9317ca3390)",
    mask: "url(#mask-f75b960b-4b66-498f-845f-5a9317ca3390)",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsHistory);
export default __webpack_public_path__ + "static/media/logsHistory.5fe7328b842b5fc4e9fc2275ea1999dd.svg";
export { ForwardRef as ReactComponent };